import React from 'react';
import { Stack } from '@mui/material';
import { ArrowBackIcon, DataGrid, Loader } from '@orijinworks/frontend-commons';
import { AuditHeader, DataGridWrapper, RoundIconButton } from './Audit.styles';
import { AuditUpdatedByTypographySX, NavyMainTypography } from '../../Feeds.style';
import { useAuditHook } from './useAuditHook';
import { AuditToggleButton } from './AuditToggleButton';
import DeleteModal from '../../../../shared/components/DeleteModal/DeleteModal';
import { Link } from 'react-router-dom';
import { FeedDrawer } from '../../../../shared/components/feed-drawer';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { ExportAllWithEmail } from '../../../../shared';

const Audit = () => {
    const { columns,
        modalRef,
        data,
        pageSize,
        loading,
        exportLoading,
        selectedType,
        totalRecordsCount,
        onFilterChangeHandler,
        onTypeChangeHandler,
        handleSelectedChangeHandler,
        refreshContactsHandler,
        onPageChangeHandler,
        onPageSizeChangeHandler,
        onSortChangeHandler,
        onTogglaModalHandlerHandler,
        onContinueDeleteModalHandlerHandler,
        handleBackClick,
        getModalTitle,
        getModalDescription,
        getFeedDrawerProps,
        isExportAllSuccess,
        isExportAllModalOpen,
        handleOpenExportAllModal,
        handleCloseExportAllModal,
        handleExportAll,
    } = useAuditHook();
   
    return (
        <>
            <Loader isLoading={exportLoading} />
            <Stack
                height="100%"
                backgroundColor="white"
                direction="column" spacing={2}>
                <AuditHeader>
                <Stack
                    padding={"20px"}
                    direction="row" spacing={2} alignItems="center">
                    <RoundIconButton 
                    LinkComponent={Link}
                    onClick={handleBackClick}
                    variant="contained" color="primary">
                        <ArrowBackIcon />
                    </RoundIconButton>
                    <Stack>
                        <NavyMainTypography variant="h1">
                            Audit Log
                        </NavyMainTypography>
                    </Stack>
                </Stack>
            </AuditHeader>
            <DataGridWrapper className={selectedType}>
                {columns.length > 0 && (
                    <DataGrid
                        columns={columns}
                        data={[...data]}
                        pageSize={pageSize}
                        pageSizeOptions={[5, 10, 25, 50]}
                        paginationMode={'server'}
                        isLoading={loading}
                        onSelectionChange={handleSelectedChangeHandler}
                        showClearSelectionButton={true}
                        serverSidePaginationProps={{
                            onPageChange: onPageChangeHandler,
                            onPageSizeChange: onPageSizeChangeHandler,
                            onSortChange: onSortChangeHandler,
                            onFilterChange: onFilterChangeHandler,
                            totalRecordsCount
                        }}
                        onRefreshHandler={refreshContactsHandler}
                        hasActionColumn={true}
                        primaryButtonProps={data.length > 0 ? {
                            sx: {width: 142},
                            text: 'Export',
                            variant: 'contained',
                            startIcon: <SaveAltIcon />,
                            endIcon: <ArrowDropDownIcon />,
                            dropdownOptions:  [
                              {
                                icon: <SystemUpdateAltIcon />,
                                label: 'Export All',
                                value: 'exportAll',
                                onClick: handleOpenExportAllModal,
                              },
                            ],
                            onDropdownOptionSelect: () => {},
                          } : false}
                
                        headerStartComponent={<AuditToggleButton isDisabled={loading} selectedType={selectedType} onTypeChange={onTypeChangeHandler} />}
                        tdStyles={{
                            createdAt: {
                                width: 100,
                                maxWidth: 100,
                                overflow: 'hidden',
                            },
                            recipient: {
                                width: 250,
                                maxWidth: 250,
                                overflow: 'hidden',
                            },
                            sender: {
                                width: 250,
                                maxWidth: 250,
                                overflow: 'hidden',
                            },
                            isDeleted: {
                                width: 110,
                                maxWidth: 110,
                                overflow: 'hidden',
                            },
                            message: {
                                width: 280,
                                minWidth: 180,
                                maxWidth: 280,
                                overflow: 'hidden',
                            },
                            subject: {
                                width: 280,
                                minWidth: 180,
                                maxWidth: 280,
                                overflow: 'hidden',
                            },
                            performedBy: AuditUpdatedByTypographySX,
                            adminName: {
                                width: 200,
                                maxWidth: 200,
                                overflow: 'hidden',
                            },
                            actionTypes: {
                                width: 164,
                                maxWidth: 164,
                                overflow: 'hidden',
                            },
                            dateOfLastAction: {
                                width: 100,
                                maxWidth: 100,
                                overflow: 'hidden',
                            },
                            statuses: {
                                width: 140,
                                maxWidth: 140,
                                overflow: 'hidden',
                            },
                            learner: {
                                width: 360,
                                maxWidth: 360,
                                overflow: 'hidden',
                            },
                            fileTypes: {
                                width: 220,
                                minWidth: 220,
                                maxWidth: 220,
                                overflow: 'hidden',
                            }
                        }}
                    />
                )}
            </DataGridWrapper>
            <DeleteModal
                modalRef={modalRef}
                title={getModalTitle()}
                description={getModalDescription()}
                open={false}
                onClose={onTogglaModalHandlerHandler}
                onContinue={onContinueDeleteModalHandlerHandler}
            />
            <FeedDrawer {...getFeedDrawerProps()} />
        </Stack>
        <ExportAllWithEmail
            open={isExportAllModalOpen}
            onClose={handleCloseExportAllModal}
            onExport={handleExportAll}
            isSuccess={isExportAllSuccess}
        />
        </>
    );
};

export default Audit;